<div class="criterion-row-container" cdkDrag cdkDragBoundary=".rules-list" cdkDragLockAxis="y">
    <div [class]="tabClass()">
        @if (displayIndex()) {
            {{ index() + 1 }}
        }
    </div>
    <div class="criterion-container">
        <div class="criterion-content">
            <div class="criterion-type-badge">
                <fa-icon [icon]="faGlobe" />
                {{ type }}
            </div>
            <div class="cmt-level-row">
                <mat-form-field class="cmt-level-dropdown">
                    <mat-label>Hierarchy Level</mat-label>
                    <mat-select [formControl]="criterionForm.controls.cmtLevel">
                        @for (level of cmtLevels(); track $index) {
                            <mat-option [value]="level.value" (click)="onLevelSelect()"
                                >{{ level.displayName }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.cmtLevel.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <div class="typeahead-container">
                    <r1-compass-lib-typeahead-search
                        [valueFormControl]="criterionForm.controls.cmtCategory"
                        [displayFormControl]="criterionForm.controls.cmtCategory"
                        [resultDisplayPropertyPath]="'name'"
                        [resultValuePropertyPath]="'code'"
                        [disabled]="displayOnly()"
                        [searchResults]="categoryTypeaheadResults"
                        (search)="onTypeaheadSearch($event)" />
                </div>
            </div>
            <div class="web-activity-row">
                <mat-form-field class="web-activity-dropdown">
                    <mat-label>Web Activity Period</mat-label>
                    <mat-select [formControl]="criterionForm.controls.webActivityPeriod">
                        @for (period of webActivityPeriodFields(); track $index) {
                            <mat-option [value]="period.name">{{ period.displayName }}</mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.webActivityPeriod.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <div class="checkbox-container">
                    <mat-checkbox [formControl]="criterionForm.controls.not">Not</mat-checkbox>
                </div>
                <mat-form-field class="comparator-dropdown">
                    <mat-label>Comparator</mat-label>
                    <mat-select [formControl]="criterionForm.controls.comparator">
                        @for (comparator of comparators; track $index) {
                            <mat-option [value]="comparator.value">{{ comparator.label }}</mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.comparator.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="value-input">
                    <mat-label>Value</mat-label>
                    <input matInput [formControl]="criterionForm.controls.value1.controls.value" />
                    @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="criterion-options-container">
            @if (deletable()) {
                <div
                    class="trash-icon-container"
                    role="button"
                    aria-disabled="true"
                    (click)="onDelete()"
                    (keydown)="onDelete()">
                    <fa-icon [icon]="faTrash" />
                </div>
            } @else {
                <div class="empty-icon-container"></div>
            }
        </div>
    </div>
</div>
